// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"57":"b31a6ed4","241":"83a6bb20","972":"f9aadbc9"}[chunkId] + ".css";
};